"use client"

import { useTranslation } from "react-i18next"
import ErrorBoundary from "@/components/global/error-boundary"
import CommonViewMoreButton from "@/components/pop-ui/common-view-more-button"
import { GuessYouLikeSection } from "@/modules/product/components/guess-you-like-section"

export default function NotFound() {
	const { t } = useTranslation()

	return (
		<div className="flex flex-col justify-center items-center py-40">
			<div className="flex flex-col items-center justify-center w-full max-w-[1200px] px-4">
				<p className="text-gray-600 mb-8">{t("notFound.message")}</p>
				<CommonViewMoreButton href="/" className="mb-12">
					<span>{t("notFound.backToHome")}</span>
				</CommonViewMoreButton>
				<div className="w-full">
					<ErrorBoundary>
						<GuessYouLikeSection q="推荐商品" id="404" />
					</ErrorBoundary>
				</div>
			</div>
		</div>
	)
}
